export default __webpack_public_path__ + "static/media/liquidity-providers.9c85808e.jpg";